import React, { useState, useEffect } from 'react';
import { Card, CardContent } from './ui/card';
import { Timer } from 'lucide-react';

const CountdownWidget = ({ eventDate, eventName }) => {
  const [timeLeft, setTimeLeft] = useState(null);

  useEffect(() => {
    if (!eventDate) return;

    const calculate = () => {
      const now = new Date();
      const target = new Date(eventDate);
      const diff = target - now;

      if (diff <= 0) {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0, passed: true });
        return;
      }

      setTimeLeft({
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((diff / (1000 * 60)) % 60),
        seconds: Math.floor((diff / 1000) % 60),
        passed: false
      });
    };

    calculate();
    const interval = setInterval(calculate, 1000);
    return () => clearInterval(interval);
  }, [eventDate]);

  if (!eventDate || !timeLeft) return null;

  const blocks = [
    { label: 'Days', value: timeLeft.days },
    { label: 'Hours', value: timeLeft.hours },
    { label: 'Minutes', value: timeLeft.minutes },
    { label: 'Seconds', value: timeLeft.seconds },
  ];

  if (timeLeft.passed) {
    return (
      <Card className="border-0 shadow-sm bg-gradient-to-r from-green-500 to-emerald-600 text-white" data-testid="countdown-widget">
        <CardContent className="p-6 text-center">
          <Timer className="h-8 w-8 mx-auto mb-2" />
          <p className="font-heading text-xl font-bold">The Event Has Started!</p>
          {eventName && <p className="text-sm text-white/80 mt-1">{eventName}</p>}
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="border-0 shadow-sm bg-gradient-to-r from-maroon to-maroon-hover text-white overflow-hidden" data-testid="countdown-widget">
      <CardContent className="p-6">
        <div className="flex items-center gap-2 mb-4">
          <Timer className="h-5 w-5 text-gold" />
          <p className="text-sm font-medium text-white/80">Countdown to Reunion</p>
        </div>
        <div className="grid grid-cols-4 gap-3">
          {blocks.map((block) => (
            <div key={block.label} className="text-center">
              <div className="bg-white/15 backdrop-blur-sm rounded-xl p-3">
                <p className="font-mono text-3xl md:text-4xl font-bold tabular-nums">
                  {String(block.value).padStart(2, '0')}
                </p>
              </div>
              <p className="text-xs text-white/60 mt-1.5 uppercase tracking-wider">{block.label}</p>
            </div>
          ))}
        </div>
        {eventName && (
          <p className="text-sm text-gold mt-4 text-center font-medium">{eventName}</p>
        )}
      </CardContent>
    </Card>
  );
};

export default CountdownWidget;
